import Vue from 'vue'
import Vuex from 'vuex'
import { adminItemClass } from './modules/adminItemClass.module'
import { adminItemProdDb } from './modules/adminItemProdDb.module'
import { adminMarket } from './modules/adminMarket.module'
import { adminUser } from './modules/adminUser.module'
import { auth } from './modules/auth.module'
import { customerSearch } from './modules/customerSearch.module'
import { itemSearch } from './modules/itemSearch.module'
import { pubQuoteEdit } from './modules/pubQuoteEdit.module'
import { pubQuoteSearch } from './modules/pubQuoteSearch.module'
import { quoteWorkflow } from './modules/quoteWorkflow.module'
import { adminItemImages } from './modules/adminItemImages.module'
import { adminPubSiteAdmin } from './modules/adminPubSiteAdmin.module'
import { tazApi } from './modules/tazApi.module'
import { capsApi } from './modules/capsApi.module'
import { folderFileNav } from './modules/folderFileNav.module'
import { adminQteTemplate } from './modules/adminQteTemplate.module'
import { adminItemPromotion } from './modules/adminItemPromotion.module'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    error: null
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
        return state.error
    },

  },
  mutations: {
    setLoading (state, payload) {
      // console.log('set loading to: ' + payload)
      state.loading = payload
    },
    setError (state, payload) {
        // console.log(JSON.stringify(payload))
        state.error = payload
    },
    clearError (state) {
        state.error = null
    }

  },
  actions: {

  },
  modules: {
      adminItemClass,
      adminItemProdDb,
      adminMarket,
      adminUser,
      auth,
      customerSearch,
      itemSearch,
      pubQuoteEdit,
      pubQuoteSearch,
      quoteWorkflow,
      adminItemImages,
      adminPubSiteAdmin,
      tazApi,
      capsApi,
      folderFileNav,
      adminQteTemplate,
      adminItemPromotion,
  }
})
